import React, { ChangeEvent } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Spinner,
} from 'reactstrap';

interface TotpModalProps {
  isOpen: boolean;
  step: 1 | 2;
  code: string;
  loading: boolean;
  error: string | null;
  onSendCode: () => void;
  onCodeChange: (code: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
  onResend: () => void;
}

function TotpModal(props: TotpModalProps) {
  const { isOpen, step, code, loading, error, onSendCode, onCodeChange, onConfirm, onCancel, onResend } = props;

  const handleCodeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    onCodeChange(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && code.length === 6 && !loading) {
      onConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} className="modal-dialog-centered">
      <ModalHeader>Verificación de identidad</ModalHeader>
      <ModalBody>
        {step === 1 && (
          <p>Vamos a enviar un código de verificación a tu correo electrónico para confirmar tu identidad.</p>
        )}
        {step === 2 && (
          <>
            <p>Ingresá el código de 6 dígitos que enviamos a tu correo electrónico.</p>
            <Input
              type="text"
              inputMode="numeric"
              pattern="\d{6}"
              maxLength={6}
              value={code}
              onChange={handleCodeChange}
              onKeyDown={handleKeyDown}
              placeholder="000000"
              disabled={loading}
              style={{ textAlign: 'center', fontSize: '1.5rem', letterSpacing: '0.5rem' }}
              autoFocus
            />
          </>
        )}
        {error && (
          <p className="text-danger mt-2 mb-0">{error}</p>
        )}
      </ModalBody>
      <ModalFooter>
        {step === 1 && (
          <>
            <Button color="success" onClick={onSendCode} disabled={loading}>
              {loading ? <Spinner size="sm" /> : 'Enviar código'}
            </Button>
            <Button color="primary" onClick={onCancel} disabled={loading}>
              Cancelar
            </Button>
          </>
        )}
        {step === 2 && (
          <>
            <Button color="success" onClick={onConfirm} disabled={loading || code.length !== 6}>
              {loading ? <Spinner size="sm" /> : 'Confirmar'}
            </Button>
            <Button color="link" onClick={onResend} disabled={loading} className="mr-auto">
              Reenviar código
            </Button>
            <Button color="primary" onClick={onCancel} disabled={loading}>
              Cancelar
            </Button>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default TotpModal;
